/*
 * @Author: 黄浩
 * @Date: 2021-11-15 11:33:42
 * @LastEditTime: 2024-01-24 15:44:02
 * @LastEditors: Gyan
 * @Descripttion:
 * @FilePath: \dhr_frontend\src\routes\modules\serviceConfig.js
 */
export default [
  {
    name: "targetList",
    path: "/serviceConfig/targetList",
    component: () => import("@/views/serviceConfig/targetList/index.vue"),
    meta: {
      title: "目标配置",
    },
  },
  {
    name: "targetStaffing",
    path: "/serviceConfig/targetStaffing",
    component: () => import("@/views/serviceConfig/targetStaffing/index.vue"),
    meta: {
      title: "目标名单配置",
    },
  },
  {
    name: "humanEfficiencyConfig",
    path: "/serviceConfig/humanEfficiencyConfig",
    component: () =>
      import("@/views/serviceConfig/humanEfficiencyConfig/index.vue"),
    meta: {
      title: "人效配置",
    },
  },
  {
    name: "moreDeptSetting",
    path: "/serviceConfig/moreDeptSetting",
    component: () => import("@/views/serviceConfig/moreDeptSetting/index.vue"),
    meta: {
      title: "多部门配置",
    },
  },
  {
    name: "ActualListConfig",
    path: "/serviceConfig/actualListConfig",
    component: () => import("@/views/serviceConfig/actualListConfig/index.vue"),
    meta: {
      title: "实际名单配置",
    },
  },
  {
    name: "removeCaliberConfig",
    path: "/serviceConfig/removeCaliberConfig",
    component: () => import("@/views/serviceConfig/removeCaliber/index.vue"),
    meta: {
      title: "剔除口径配置",
    },
  },
  {
    name: "personEfficiencyManagement",
    path: "/serviceConfig/personEfficiencyManagement",
    component: () => import("@/views/serviceConfig/personEfficiencyManagement/index.vue"),
    meta: {
      title: "人效管理",
    },
  },
];
